import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { qrReviewApi } from './qr-review.api';
import type { QrReviewListParams } from '../types';
import { STALE_TIME } from '@/lib/query/stale-times';

export const qrReviewKeys = {
  all: ['qr-review'] as const,
  lists: () => [...qrReviewKeys.all, 'list'] as const,
  list: (filters: QrReviewListParams) =>
    [...qrReviewKeys.lists(), filters] as const,
  details: () => [...qrReviewKeys.all, 'detail'] as const,
  detail: (id: number) => [...qrReviewKeys.details(), id] as const,
  metrics: () => [...qrReviewKeys.all, 'metrics'] as const
};

export const qrReviewQueries = {
  list: (filters: QrReviewListParams = {}) =>
    queryOptions({
      queryKey: qrReviewKeys.list(filters),
      queryFn: () => qrReviewApi.getList(filters),
      placeholderData: keepPreviousData,
      // Batches land in this queue via photo-scanning's transfer-to-QA, which
      // invalidates `photoScanningKeys` — never `qrReviewKeys`. Nothing on this
      // side marks the queue stale when upstream hands work over.
      staleTime: STALE_TIME.live
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: qrReviewKeys.detail(id),
      queryFn: () => qrReviewApi.getById(id),
      refetchInterval: 5000
    }),

  metrics: () =>
    queryOptions({
      queryKey: qrReviewKeys.metrics(),
      queryFn: () => qrReviewApi.getMetrics(),
      staleTime: STALE_TIME.metrics
    })
};
